module.exports = __webpack_public_path__ + "static/media/persona1.0105f479.png";